
<div>
    <h4 class="section-title">
        {{ $t("supplierDetail.nav.payments") }}
    </h4>

    <EmptySection v-show="!hasPaymentsData" :message="$t('supplierDetail.payments.nodata')"></EmptySection>
    <InvoiceDetailTable
        v-show="hasPaymentsData"
        :table-settings="paymentsTableConfig"
        :debounce="filterDebounce"
        :sort-options="paymentsSortOptions"
        :hash="hash"
        :version="version"
        :type="type"
        :typeId="typeId"
        ref="payments_data_table"
    >
        <template v-slot:cell(date)="row">
            {{ row.value }}
        </template>

        <template v-slot:cell(details)="row">
            <div v-if="row.item.tender && type == 'supplier'" :class="{'mb-1': hasAnyInfo(row.item)}">
                <router-link
                    :to="{ name: 'tender-detail', params: { version: version, hash: hash, slug: row.item.tender.slug}}"
                    v-if="type=='supplier'">
                    {{ row.item.tender.title }}
                </router-link>
                <span v-else>
                    <b>{{ row.item.tender.title }}</b>
                </span>
            </div>
            <div v-else-if="row.item.note" :class="{'mb-1': hasAnyInfo(row.item)}">
                <b>{{ row.item.note }}</b>
            </div>

            <PaymentDetailRow v-if="row.item.accounting_number && row.item.src !== 'pap'">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.accounting_number") }}
                </template>
                <template v-slot:content>
                    {{ row.item.accounting_number }}
                </template>
            </PaymentDetailRow>

            <PaymentDetailRow v-if="row.item.accounting_name">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.accounting_name") }}
                </template>
                <template v-slot:content>
                    {{ row.item.accounting_name }}
                </template>
            </PaymentDetailRow>

            <PaymentDetailRow v-if="row.item.budget_unit_number">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.budget_unit_number") }}
                </template>
                <template v-slot:content>
                    {{ row.item.budget_unit_number }}
                </template>
            </PaymentDetailRow>

            <PaymentDetailRow v-if="row.item.budget_unit_name">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.budget_unit_name") }}
                </template>
                <template v-slot:content>
                    {{ row.item.budget_unit_name }}
                </template>
            </PaymentDetailRow>

            <PaymentDetailRow v-if="row.item.budget_paragraph_number">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.budget_paragraph_number") }}
                </template>
                <template v-slot:content>
                    {{ row.item.budget_paragraph_number }}
                </template>
            </PaymentDetailRow>

            <PaymentDetailRow v-if="row.item.budget_paragraph_name">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.budget_paragraph_name") }}
                </template>
                <template v-slot:content>
                    {{ row.item.budget_paragraph_name }}
                </template>
            </PaymentDetailRow>

            <PaymentDetailRow v-if="row.item.department">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.department") }}
                </template>
                <template v-slot:content>
                    {{ row.item.department }}
                </template>
            </PaymentDetailRow>

            <PaymentDetailRow v-if="row.item.person">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.person") }}
                </template>
                <template v-slot:content>
                    {{ row.item.person }}
                </template>
            </PaymentDetailRow>

            <PaymentDetailRow v-if="row.item.note2">
                <template v-slot:header>
                    {{ $t("supplierDetail.payments.table.head.note2") }}
                </template>
                <template v-slot:content>
                    {{ row.item.note2 }}
                </template>
            </PaymentDetailRow>
        </template>
    </InvoiceDetailTable>
</div>
